import { CreateDispatchPassengerDto, RowDispatchPassengerDto, UpdateDispatchPassengerDto } from "@/dtos";
import { DispatchPassenger, DispatchPassengerDetail, Fare, Passenger } from "@/entities";
import { parseToLocalDateTimeFromUtc } from "@/helpers/utilities";

export const formatRowDispatchPassengerDto = (dispatchPassengers: DispatchPassenger[]): RowDispatchPassengerDto[] => {
    return dispatchPassengers.map(x => {
        const row: RowDispatchPassengerDto = {
            ...x,
            active: x.is_active ? 'Activo' : 'Inactivo',
            value: (x.fare.value / 100).toFixed(2),
            passenger_label: x.passenger.first_name + " " + x.passenger.last_name,
            vehicle_label: x.details.vehicle,
            trip_pattern_label: x.details?.trip_pattern ?? '',
            date_label: x.date.toString(),
            board: (x.on_board) ? 'Si' : 'No',
            date_board: (x.date_on_board) ? parseToLocalDateTimeFromUtc(x.date_on_board as string) : "S/N",
            stop_label: x.details.stop ?? 'S/N'
        }

        return row;
    });
}

export const formatDispatchPassengerDto = (dispatchPassengerFormDto): CreateDispatchPassengerDto | UpdateDispatchPassengerDto => {
    const details: DispatchPassengerDetail = {
        company: dispatchPassengerFormDto.company,
        vehicle: dispatchPassengerFormDto.vehicle,
        trip_pattern: dispatchPassengerFormDto.trip_pattern,
        stop: dispatchPassengerFormDto.stop
    }

    const result: CreateDispatchPassengerDto = {
        company_id: dispatchPassengerFormDto.company_id,
        vehicle_id: dispatchPassengerFormDto.vehicle_id,
        dispatch_id: dispatchPassengerFormDto.dispatch_id,
        stop_id: dispatchPassengerFormDto.stop_id,
        date: dispatchPassengerFormDto.date,
        passenger: { id: dispatchPassengerFormDto.passenger_id } as Passenger,
        fare: { id: dispatchPassengerFormDto.fare_id } as Fare,
        details: details
    };

    return result;
}